import occInstance from '@/api/instances/occ';
import {ApiDefaults} from '@/constants/api.js';

const BenefitMessagingApi = {
  async freeShippingThreshold(fields = ApiDefaults.DEFAULT) {
    try {
      const url = `delivery/fulfillmentOption/message`;
      const params = {
        fields,
      };
      const response = await occInstance.get(url, {params});
      return response?.data?.determinantThreshold;
    } catch (error) {
      console.error('Failed to fetch the free shipping threshold', error);
    }
  },
};

export {BenefitMessagingApi};
